import { createSignal, onMount } from 'solid-js'
import { res2json } from '@/utils'

export default function Login() {
  // http://localhost:5173/login/tJUSrNyR
  const matches = document.location.pathname.match(/^\/login\/(\w+)$/)
  if (!matches) {
    return (<div class="fixed inset-0 flex items-center justify-center p-8 lg:p-0 text-lg">访问地址失效，或您的账号已在其它地方登陆，请联系管理员</div>)
  }

  const code = matches[1]
  const [username, setUsername] = createSignal('')
  const [password, setPassword] = createSignal('')

  const [sending, setSending] = createSignal(false)
  const [errors, setErrors] = createSignal({})

  let elFocus
  onMount(() => {
    elFocus.focus()
  })

  async function submit(e) {
    e.preventDefault()
    if (sending()) {
      return
    }

    setSending(true)
    return fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        code,
        username: username(),
        password: password()
      })
    }).then(res2json).then(r => {
      if (r.status >= 400) {
        setErrors(r.data)
      } else {
        document.location.href = '/home'
      }
    }).finally(() => { setSending(false) })
  }

  return (
    <div class="fixed inset-0 flex items-center justify-center">
      <form onSubmit={submit} class="flex flex-col gap-6 w-full max-w-sm px-4 lg:px-0">
        <h1 class="text-2xl">后台登陆</h1>
        <div class="form-control">
          <div class="label"><span class="label-text">用户名</span></div>
          <input ref={elFocus} type="text" value={username()} onChange={e => setUsername(e.target.value)} class="input input-bordered" placeholder="请输入您的用户名" required />
          {errors().username && (<div class="label"><span class="label-text-alt text-error">{errors().username}</span></div>)}
        </div>
        <div class="form-control">
          <div class="label"><span class="label-text">登陆密码</span></div>
          <input type="password" onChange={e => setPassword(e.target.value)} class="input input-bordered" placeholder="请输入登陆密码" required />
          {errors().password && (<div class="label"><span class="label-text-alt text-error">{errors().password}</span></div>)}
        </div>
        {errors().default && (<div class="text-error">{errors().default}</div>)}
        <div class="form-control">
          <button type="submit" class="btn btn-success text-white w-full" disabled={sending()}>提交登陆</button>
        </div>
      </form>
    </div>
  )
}
